import React from 'react';
import { clsx } from 'clsx';
import PropTypes from 'prop-types';

import Loading from 'Components/Globals/Loading/index.js';

import styles from './styles.module.scss';

const PageLoading = ({ className, status, color, size }) => {
	return (
		<div className={clsx([styles.wrapper, className])}>
			<Loading
				status={status}
				color={color}
				size={size}
			/>
		</div>
	);
};

PageLoading.propTypes = {
	className: PropTypes.string,
	status: PropTypes.string,
	color: PropTypes.string,
	size: PropTypes.string,
};

PageLoading.defaultProps = {
	className: '',
};

export default PageLoading;
